import { createReducer } from "./utils.js";
import { GET_TEMPLATES_REQUEST, GET_TEMPLATES_SUCCESS, GET_TEMPLATES_FAILURE, SNACK_SET } from "./constants.js";

const defaultState = {
    loading: false,
    errorMessage: null,
    templates: []
    };

export const reducer = createReducer(defaultState, {
    [GET_TEMPLATES_REQUEST]: handleGetTemplatesRequest,
    [GET_TEMPLATES_SUCCESS]: handleGetTemplatesSuccess,
    [GET_TEMPLATES_FAILURE]: handleGetTemplatesFailure
});

function handleGetTemplatesRequest(state) {
    return {
        ...state,
        templates: [],
        loading: true
    };
}

function handleGetTemplatesSuccess(state, { payload: { templates } }) {
    return {
        ...state,
        templates,
        loading: false,
        errorMessage: null
    };
}

function handleGetTemplatesFailure(state, { payload: { error } }) {
    return {
        ...state,
        loading: false,
        errorMessage: error
    };
}

export function getTemplates(tenant_id, sucursal_id) {
    return async(dispatch, getState, { services: { dataSource } }) => {
        dispatch({ type: GET_TEMPLATES_REQUEST });
        try {
            const templates = await dataSource.getTemplates(tenant_id, sucursal_id);
            dispatch({ type: GET_TEMPLATES_SUCCESS, payload: { templates } });
        } catch (error) {
            dispatch({ type: GET_TEMPLATES_FAILURE, payload: { error } });
            const snack = {
                open: true,
                message: 'Error al obtener las plantillas' + error.message,
                severity: 'error'
            };
            dispatch({ type: SNACK_SET, payload: { snack } });
        }
    };
}